module.exports = __webpack_public_path__ + "static/media/viewie-logo-tekst-wit.6ff35115.svg";